import { useMemo } from 'react';

import { useTranslations } from 'next-intl';

const usePeriodText = (billingPeriod: string, billingFrequency: number, billingUnit: string) => {
  const tCheckout = useTranslations('checkout');
  const tSubscriptionPlans = useTranslations('subscriptionPlans');

  return useMemo(() => {
    const getUnitText = (billingFrequency: number, billingUnit: string) => {
      if (billingFrequency === 1) {
        return tSubscriptionPlans(billingUnit).toLocaleLowerCase();
      }
      return tSubscriptionPlans(billingUnit + 's').toLocaleLowerCase();
    };

    if (billingPeriod === 'custom') {
      if (billingUnit === 'year') {
        return tCheckout('customPeriodOneYear', {
          frequency: billingFrequency,
          unit: tSubscriptionPlans(billingUnit),
        });
      }

      return tCheckout('customPeriod', {
        frequency: billingFrequency,
        unit: billingUnit ? getUnitText(billingFrequency, billingUnit) : billingUnit,
      });
    } else if (billingPeriod) {
      return tCheckout(billingPeriod);
    }
    return '';
  }, [billingPeriod, billingFrequency, billingUnit, tCheckout, tSubscriptionPlans]);
};

export default usePeriodText;
